import { lazy } from 'react';

const NominationProducerConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/producer/consult/nomination-info',
			component: lazy(() => import('./NominationContainer'))
		}
	]
};

export default NominationProducerConfig;



